<template>
  <b-container v-if="page === 'LIST_TEMPLATE'" data-app fluid>
    <b-modal id="modal-patient-permission" centered scrollable size="lg">
      <template #modal-title>
        {{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.patientPermisions"
          )
        }}
        <b-badge v-if="patientPermission && patientPermission.secured" class="ml-2 text-uppercase" pill
          variant="success">{{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.unShared"
            )
          }}
        </b-badge>
        <b-badge v-else class="ml-2 text-uppercase" pill variant="warning">{{
          $t("public.views.Pages.Professional.Contact.HistoricClinics.shared")
        }}
        </b-badge>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button v-if="patientPermission && patientPermission.secured" class="float-right mr-2" variant="warning"
            @click="patientPermissionCreate">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.share"
              )
            }}
          </b-button>
          <b-button v-if="patientPermission && !patientPermission.secured" class="float-right mr-2" variant="success"
            @click="patientPermissionCreate">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.unshare"
              )
            }}
          </b-button>
          <b-button v-if="patientPermission && !patientPermission.secured" class="float-right mr-2" variant="warning"
            @click="changeNotSecuredPatientPermission()">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.btnRefresh"
              )
            }}
          </b-button>
          <b-button class="float-right mr-2" variant="secondary" @click="$bvModal.hide('modal-patient-permission')">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.btnClose"
              )
            }}
          </b-button>
        </div>
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Professional.Contact.HistoricClinics.btnClose")
      }}
      </template>
      <template>
        <b-alert show variant="warning">{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.fieldsShared"
          )
        }}
        </b-alert>
        <div>
          <h4>
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.templates"
              )
            }}:
          </h4>
          <tree ref="tree" v-model="treeModel" :data="items" :options="optionsTree" />
        </div>
        <div>
          <h4>
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.notes"
              )
            }}:
          </h4>
          <tree ref="tree" v-model="treeModelNotes" :data="itemsNotes" :options="optionsTree" />
        </div>
      </template>
    </b-modal>
    <b-modal id="modal-professional-permission" centered size="xl" @ok="openProfessionalPermissionCreate">
      <template #modal-title>
        {{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.professionalPermisions"
          )
        }}
      </template>
      <template #modal-ok>
        {{ $t("public.views.Pages.Professional.Contact.HistoricClinics.add") }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Professional.Contact.HistoricClinics.btnClose")
      }}
      </template>
      <template>
        <v-data-table :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'fas fa-arrow-left',
              lastIcon: 'fas fa-arrow-right',
              prevIcon: 'fas fa-minus',
              nextIcon: 'fas fa-plus',
              'items-per-page-options': [10, 25, 50],
            }" :headers="headersProfessionalPermissions" :items="professionalPermissions" :options.sync="pagination"
          item-key="id">
          <template v-slot:item.professional="{ item }">
            <b-list-group-item v-if="item.professional" class="d-flex align-items-center border-0 p-0">
              <b-avatar v-bind:src="item.professional.avatarUrl
                ? item.professional.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <div class="media-support-info ml-3">
                <p class="mb-0 font-size-16">{{ item.professional.name }}</p>
                <p class="mb-0 font-size-12">
                  {{ item.professional.lastname }}
                </p>
              </div>
            </b-list-group-item>
          </template>
          <template v-slot:item.permission="{ item }">
            <div v-if="item.permission !== null">
              <div v-if="item.permission === 'READ'">
                <b-badge class="text-uppercase" variant="success">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.read"
                  )
                }}
                </b-badge>
              </div>
              <div v-else>
                <b-badge class="text-uppercase" variant="warning">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.write"
                  )
                }}
                </b-badge>
              </div>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="div-table-data">
              <button :id="'btnProfessionalPermission' + item.id" class="item"
                v-on:click="openProfessionalPermissionUpdate(item.id)">
                <i class="ri-lock-line"></i>
              </button>
              <b-popover :target="'btnProfessionalPermission' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.refreshPermision"
                  )
                }}
                </template>
              </b-popover>
              <button :id="'btnDelete' + item.id" class="item" v-on:click="deleteProfessionalPermission(item.id)">
                <i class="ri-delete-bin-line"></i>
              </button>
              <b-popover :target="'btnDelete' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.deletePermision"
                  )
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>
      </template>
    </b-modal>
    <b-modal id="modal-professional-permission-create" centered @ok="saveForm3">
      <template #modal-title>
        <div v-if="actionProfessionalPermisions === 'CREATE'">
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.createPermisionProf"
            )
          }}
        </div>
        <div v-if="actionProfessionalPermisions === 'UPDATE'">
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.refreshPermisionProf"
            )
          }}
        </div>
      </template>
      <template #modal-ok>
        <div v-if="actionProfessionalPermisions === 'CREATE'">
          {{
            $t("public.views.Pages.Professional.Contact.HistoricClinics.create")
          }}
        </div>
        <div v-if="actionProfessionalPermisions === 'UPDATE'">
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.refresh"
            )
          }}
        </div>
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Professional.Contact.HistoricClinics.btnClose")
      }}
      </template>
      <template>
        <b-form-group v-if="actionProfessionalPermisions === 'CREATE'" label-for="professional">
          <template slot="label">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.professional"
              )
            }}: *
          </template>

          <multiselect v-model="professionalPermission.professional" :multiple="true"
            :options="professionalPermisionsSelect" label="text" track-by="value" v-bind:class="{
              'text-danger': isFormProfessionalPermissionProfessionalErrors,
              'is-invalid': isFormProfessionalPermissionProfessionalErrors,
            }" v-bind:deselectGroupLabel="$t(
  'public.views.Pages.Professional.Contact.HistoricClinics.multiselect.deselectGroupLabel'
)
  " v-bind:deselectLabel="$t(
    'public.views.Pages.Professional.Contact.HistoricClinics.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.views.Pages.Professional.Contact.HistoricClinics.multiselect.placeholder2'
  )
    " v-bind:selectGroupLabel="$t(
    'public.views.Pages.Professional.Contact.HistoricClinics.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.views.Pages.Professional.Contact.HistoricClinics.multiselect.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.views.Pages.Professional.Contact.HistoricClinics.multiselect.selectedLabel'
  )
    " @blur="checkProfessional(professional)">
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </b-list-group-item>
            </template>
            <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                  class="option__title">
                  <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                    class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                </span></span></template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                class="multiselect__single">{{ values.length }}
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.selectedProfessionals"
                  )
                }}</span></template>
          </multiselect>
          <ul v-if="isFormProfessionalPermissionProfessionalErrors">
            <li v-for="(error, index) in validatorStep3.getErrors(
              'professionalPermission.professional'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group v-if="actionProfessionalPermisions === 'UPDATE'" label-for="professional">
          <template slot="label">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.professional"
              )
            }}: *
          </template>
          <ul class="list-group">
            <li v-if="professionalPermission.professional &&
                professionalPermission.professional.length > 0
                " class="list-group-item">
              <b-avatar v-if="professionalPermission.professional[0].avatar" class="mr-2" v-bind:src="professionalPermission.professional[0].avatarUrl
                ? professionalPermission.professional[0].avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <b-avatar v-else class="mr-2"></b-avatar>
              {{ professionalPermission.professional[0].text }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group v-slot="{ ariaDescribedby }" label-for="permission">
          <template slot="label">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.permision"
              )
            }}: *
          </template>
          <b-form-radio v-model="professionalPermission.permission" :aria-describedby="ariaDescribedby" name="permissions"
            value="READ">{{
              $t("public.views.Pages.Professional.Contact.HistoricClinics.read")
            }}
          </b-form-radio>
          <b-form-radio v-model="professionalPermission.permission" :aria-describedby="ariaDescribedby"
            name="some-permissions" value="WRITE">{{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.write"
              )
            }}
          </b-form-radio>
        </b-form-group>
      </template>
    </b-modal>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.historicClinic"
            )
          }}
          <span v-if="patient !== null && patient.name">
            - {{ patient.name }} {{ patient.lastname }} (
            {{ patient.document }} )
          </span>
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['CREATE'])" class="mr-2" style="right"
          variant="success" @click="viewCreateTemplate">{{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.btnCreate"
            )
          }}
        </b-button>
      </template>
      <template v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['LIST'])" v-slot:body>
        <v-card-title>
          <v-text-field v-model="search" hide-details single-line @blur="getAllHistoricsStore">
            <template slot="label">
              <div class="search-datatable">
                <i class="fas fa-search fa-fw"></i>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.search"
                  )
                }}
              </div>
            </template>
          </v-text-field>
          <b-button class="mt-3 ml-2" variant="primary" @click="getAllHistoricsStore">
            {{
              $t(
                "public.views.Pages.Professional.Contact.HistoricClinics.search"
              )
            }}
          </b-button>
        </v-card-title>
        <v-data-table :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'fas fa-arrow-left',
              lastIcon: 'fas fa-arrow-right',
              prevIcon: 'fas fa-minus',
              nextIcon: 'fas fa-plus',
              'items-per-page-options': [10, 25, 50],
            }" :headers="headers" :items="templates" :items-per-page="10" :options.sync="pagination" :search="search"
          :server-items-length="total" item-key="id">
          <template v-slot:item.code="{ item }">
            <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">{{
              item.patient.codeGalatea
            }}
            </b-list-group-item>
          </template>
          <template v-slot:item.professionalsGalatea="{ item }">
            <b-list-group-item v-for="(professional, index) in item.professionalsGalatea" :key="index"
              class="d-flex align-items-center border-0 p-0">
              <b-avatar v-bind:src="professional.avatarUrl
                ? professional.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <div class="media-support-info ml-3">
                <p class="mb-0 font-size-16">{{ professional.name }}</p>
                <p class="mb-0 font-size-12">
                  {{ professional.lastname }}
                </p>
              </div>
            </b-list-group-item>
          </template>
          <template v-slot:item.patient="{ item }">
            <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
              <b-avatar v-bind:src="item.patient.avatarUrl
                ? item.patient.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <div class="media-support-info ml-3">
                <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                <p class="mb-0 font-size-12">{{ item.patient.lastname }}</p>
              </div>
            </b-list-group-item>
          </template>
          <template v-slot:item.secured="{ item }">
            <div v-if="item.secured !== null && item.professionalPermissions">
              <div v-if="item.secured === false">
                <b-badge class="text-uppercase" variant="success">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.sharedPatient"
                  )
                }}
                </b-badge>
              </div>
              <div v-if="item.professionalPermissions.length !== 0">
                <b-badge class="text-uppercase" variant="success">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.sharedProfessional"
                  )
                }}
                </b-badge>
              </div>
              <div v-if="item.secured === true &&
                  item.professionalPermissions.length === 0
                  ">
                <b-badge class="text-uppercase" variant="danger">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.unShared"
                  )
                }}
                </b-badge>
              </div>
            </div>
          </template>
          <template v-slot:item.uuid="{ item }">
            <div class="div-table-data">
              <button :id="'btnProfessionalPermission' + item.id" class="item"
                v-on:click="openProfessionalPermission(item.id)">
                <i class="ri-lock-line"></i>
              </button>
              <b-popover :target="'btnProfessionalPermission' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.seeProfPermisions"
                  )
                }}
                </template>
              </b-popover>
              <button :id="'btnSee' + item.id" class="item" v-on:click="getHistoricStore(item.id, item.patient.id)">
                <i class="ri-eye-line"></i>
              </button>
              <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                <template #title>Ver historia clínica</template>
              </b-popover>
              <button v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['EDIT'])" :id="'btnSecured' + item.id"
                class="item" v-on:click="
                  openPatientPermissionCreate(
                    item.id,
                    item.patient.id,
                    item.secured
                  )
                  ">
                <i class="ri-lock-line"></i>
              </button>
              <b-popover v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['EDIT'])" :target="'btnSecured' + item.id"
                placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.seePatientPermisions"
                  )
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.sharedHC"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction></template>
      <template v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['LIST'])" v-slot:body>
        <v-card-title>
          <v-text-field v-model="searchShare" append-icon="mdi-magnify" hide-details single-line>
            <template slot="label">
              <div class="search-datatable">
                <i class="fas fa-search fa-fw"></i>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.search"
                  )
                }}
              </div>
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'fas fa-arrow-left',
              lastIcon: 'fas fa-arrow-right',
              prevIcon: 'fas fa-minus',
              nextIcon: 'fas fa-plus',
              'items-per-page-options': [10, 25, 50],
            }" :headers="headersTemplateShare" :items="templatesShare" :items-per-page="10" :search="searchShare"
          item-key="id">
          <template v-slot:item.name="{ item }">
            <div v-if="item.historicStore.name">
              {{ item.historicStore.name }}
            </div>
          </template>
          <template v-slot:item.professional="{ item }">
            <b-list-group-item v-if="item.historicStore.professional" class="d-flex align-items-center border-0 p-0">
              <b-avatar v-bind:src="item.historicStore.professional.avatarUrl
                ? item.historicStore.professional.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <div class="media-support-info ml-3">
                <p class="mb-0 font-size-16">
                  {{ item.historicStore.professional.name }}
                </p>
                <p class="mb-0 font-size-12">
                  {{ item.historicStore.professional.lastname }}
                </p>
              </div>
            </b-list-group-item>
          </template>
          <template v-slot:item.patient="{ item }">
            <b-list-group-item v-if="item.historicStore.patient" class="d-flex align-items-center border-0 p-0">
              <b-avatar v-bind:src="item.historicStore.patient.avatarUrl
                ? item.historicStore.patient.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <div class="media-support-info ml-3">
                <p class="mb-0 font-size-16">
                  {{ item.historicStore.patient.name }}
                </p>
                <p class="mb-0 font-size-12">
                  {{ item.historicStore.patient.lastname }}
                </p>
              </div>
            </b-list-group-item>
          </template>
          <template v-slot:item.secured="{ item }">
            <div v-if="item.historicStore.secured !== null">
              <div v-if="item.historicStore.secured === true">
                <b-badge class="text-uppercase" variant="success">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.sharedPatient"
                  )
                }}
                </b-badge>
              </div>
              <div v-else>
                <b-badge class="text-uppercase" variant="warning">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.unSharedPatient"
                  )
                }}
                </b-badge>
              </div>
            </div>
          </template>
          <template v-slot:item.permission="{ item }">
            <div v-if="item.permission">
              <b-badge v-if="item.permission === 'READ'" variant="warning">{{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.read"
                )
              }}
              </b-badge>
              <b-badge v-if="item.permission === 'WRITE'" variant="success">{{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.write"
                )
              }}
              </b-badge>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="div-table-data">
              <button v-if="item.permission === 'WRITE' &&
                checkPermissionProfessional('CONTACT_HISTORIC', ['EDIT'])
                " :id="'btnUpdateHistoricShare' + item.historicStore.id" class="item" v-on:click="
    getHistoricStoreShare(
      item.historicStore.id,
      item.historicStore.patient.id,
      'UPDATE'
    )
    ">
                <i class="ri-file-edit-line"></i>
              </button>
              <b-popover v-if="item.permission === 'WRITE' &&
                checkPermissionProfessional('CONTACT_HISTORIC', ['EDIT'])
                " :target="'btnUpdateHistoricShare' + item.historicStore.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.editHC"
                  )
                }}
                </template>
              </b-popover>
              <button v-if="item.permission === 'READ'" :id="'btnSeeHistoricShare' + item.historicStore.id" class="item"
                v-on:click="
                  getHistoricStoreShare(
                    item.historicStore.id,
                    item.historicStore.patient.id,
                    'READ'
                  )
                  ">
                <i class="ri-eye-line"></i>
              </button>
              <b-popover v-if="item.permission === 'READ'" :target="'btnSeeHistoricShare' + item.historicStore.id"
                placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.seeHC"
                  )
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>
      </template>
    </iq-card>
    <b-modal id="modal-create" centered @ok="saveForm">
      <template #modal-title>
        {{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.title"
          )
        }}
      </template>
      <template #modal-ok>{{
        $t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.btnCreate"
        )
      }}
      </template>
      <template #modal-cancel>{{
        $t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.btnClose"
        )
      }}
      </template>
      <p>
        {{ $t("historicclinic.contact.modalCreate.body") }}
      </p>
      <b-form-group label-for="name">
        <template slot="label">{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.name"
          )
        }}: *
        </template>
        <b-form-input id="name" v-model="name" type="text" v-bind:class="{
          'text-danger': isFormNameErrors,
          'is-invalid': isFormNameErrors,
        }" @blur="checkName(name)"></b-form-input>
        <ul v-if="isFormNameErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="patient">
        <template slot="label">{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.patient"
          )
        }}: *
        </template>
        <multiselect v-model="patient" :clear-on-select="false" :close-on-select="false" :disabled="disabled"
          :multiple="false" :options="patientSelect" :preselect-first="true" :preserve-search="true" label="text"
          track-by="value" v-bind:deselectGroupLabel="$t(
            'public.views.Pages.Professional.Contact.Recipes.multiselect.deselectGroupLabel'
          )
            " v-bind:deselectLabel="$t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.placeholder'
  )
    " v-bind:selectGroupLabel="$t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.views.Pages.Professional.Contact.Recipes.multiselect.selectedLabel'
  )
    ">
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
          <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
              class="multiselect__single">{{ values.length }}
              {{
                $t(
                  "public.views.Pages.Professional.Contact.Recipes.selectedOrganizations"
                )
              }}</span></template>
          <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                class="option__title">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                  class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
              </span></span></template>
        </multiselect>
        <ul v-if="isFormPatientErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('patient')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
  </b-container>
  <b-container v-else fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{ $t("public.views.Pages.Professional.Contact.HistoricClinics.HC") }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="listTemplate">{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.btnBack"
          )
        }}
        </b-button>
        <b-button v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['CREATE'])" class="mr-2 btn-flat" style="right"
          variant="success" @click="viewGeneratePdf">{{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.generatePdf"
            )
          }}
        </b-button>
        <!--   <b-button v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['CREATE'])" class="mr-2 btn-flat" style="right"
          variant="success" @click="viewGenerateWord">{{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.generateWord"
            )
          }}
        </b-button> -->
      </template>
      <template v-slot:body>
        <div>
          <tab-nav :tabs="true">
            <tab-nav-items :active="true" href="#tab-nav-data-demographic">
              <template v-slot:title>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.demographicData"
                  )
                }}
              </template>
            </tab-nav-items>
            <tab-nav-items :active="false" href="#tab-nav-data-note">
              <template v-slot:title>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.notesData"
                  )
                }}
              </template>
            </tab-nav-items>
            <tab-nav-items :active="false" href="#tab-nav-data-templates">
              <template v-slot:title>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.templatesData"
                  )
                }}
              </template>
            </tab-nav-items>
            <tab-nav-items :active="false" href="#tab-nav-data-record">
              <template v-slot:title>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.recordData"
                  )
                }}
              </template>
            </tab-nav-items>
            <tab-nav-items :active="false" href="#tab-nav-data-files">
              <template v-slot:title>
                {{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.recordFiles"
                  )
                }}
              </template>
            </tab-nav-items>
          </tab-nav>
          <tab-content>
            <tab-content-item id="tab-nav-data-note" :active="false">
              <div class="text-right">
                <b-button v-if="checkPermissionProfessional('CONTACT_HISTORIC', ['CREATE'])
                  " :disabled="note.content === ''" class="mr-2 btn-flat" style="right" variant="success"
                  @click="createHistoricsStoreNote">Crear
                </b-button>
              </div>
              <iq-card>
                <template v-slot:body>
                  <b-form-group label-for="note.content">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.note"
                      )
                    }}:
                    </template>
                    <ckeditor id="note.content" v-model="note.content" :config="configCK" type="classic"></ckeditor>
                  </b-form-group>
                  <b-card-group deck>
                    <b-col>
                      <b-row v-for="(note, index) in notes" :key="index">
                        <b-card bg-variant="warning" class="text-center mt-4" text-variant="black">
                          <template #header>
                            <h6 class="mb-0">
                              <div v-if="note.professional">
                                <b-avatar size="2em" v-bind:src="note.professional.avatar"></b-avatar>
                                {{ note.professional.name }}
                                {{ note.professional.lastname }}
                              </div>
                              <p class="font-size-12 mt-2">
                                {{
                                  note.createdAt | adjustToTimezone("DD/MM/YYYY HH:mm")
                                }}
                              </p>
                            </h6>
                          </template>
                          <b-card-text class="max-heigh-card-notes" v-html="note.content"></b-card-text>
                        </b-card>
                      </b-row>
                    </b-col>
                  </b-card-group>
                </template>
              </iq-card>
            </tab-content-item>
            <tab-content-item id="tab-nav-data-record" :active="false">
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headersShare" :items="shares" :options.sync="paginationShare"
                :server-items-length="totalShare" item-key="id">
                <template v-slot:item.createdAt="{ item }">
                  <div v-if="item.createdAt">
                    {{ item.createdAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.uuid="{ item }">
                  <div class="div-table-data">
                    <button :id="'btnUpdate' + item.id" class="item" v-on:click="openModal('UPDATE', item.id)">
                      <i class="ri-eye-line"></i>
                    </button>
                    <b-popover :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
                      <template #title>Ver grabación</template>
                    </b-popover>
                  </div>
                </template>
                <template v-slot:item.category="{ item }">
                  {{
                    $t("public.views.Pages.Share.categories." + item.category)
                  }}
                </template>

                <template v-slot:item.filename="{ item }">
                  <div v-if="item.filename">
                    <i v-if="item.filename
                      .substring(
                        item.filename.lastIndexOf('.') + 1,
                        item.filename.length
                      )
                      .toLowerCase() === 'mp4'
                      " class="fas fa-file-video"></i>
                    <i v-else-if="item.filename
                      .substring(
                        item.filename.lastIndexOf('.') + 1,
                        item.filename.length
                      )
                      .toLowerCase() === 'pdf'
                      " class="fas fa-file-pdf"></i>
                    <i v-else-if="item.filename
                      .substring(
                        item.filename.lastIndexOf('.') + 1,
                        item.filename.length
                      )
                      .toLowerCase() === 'png' ||
                      item.filename
                        .substring(
                          item.filename.lastIndexOf('.') + 1,
                          item.filename.length
                        )
                        .toLowerCase() === 'jpg' ||
                      item.filename
                        .substring(
                          item.filename.lastIndexOf('.') + 1,
                          item.filename.length
                        )
                        .toLowerCase() === 'jpeg' ||
                      item.filename
                        .substring(
                          item.filename.lastIndexOf('.') + 1,
                          item.filename.length
                        )
                        .toLowerCase() === 'gif'
                      " class="fas fa-file-image"></i>
                    <i v-else-if="item.filename
                      .substring(
                        item.filename.lastIndexOf('.') + 1,
                        item.filename.length
                      )
                      .toLowerCase() === 'word'
                      " class="fas fa-file-word"></i>
                    <i v-else-if="item.filename
                      .substring(
                        item.filename.lastIndexOf('.') + 1,
                        item.filename.length
                      )
                      .toLowerCase() === 'xls'
                      " class="fas fa-file-excel"></i>
                    <i v-else-if="item.filename
                      .substring(
                        item.filename.lastIndexOf('.') + 1,
                        item.filename.length
                      )
                      .toLowerCase() === 'txt'
                      " class="fas fa-file-alt"></i>
                    <i v-else class="far fa-file"></i>
                    {{ item.filename }}
                  </div>
                </template>
              </v-data-table>
            </tab-content-item>
            <tab-content-item id="tab-nav-data-files" :active="false">

              <HistoricsFiles :patientId="patientId"></HistoricsFiles>
            </tab-content-item>
            <tab-content-item id="tab-nav-data-demographic" :active="true">
              <b-row>
                <b-col cols="6">
                  <b-form-group label-for="demographic.name">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.name"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.name" v-model="demographic.name" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.lastname">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.lastname"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.lastname" v-model="demographic.lastname" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.email">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.email"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.email" v-model="demographic.email" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.date">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.birth"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.date" v-model="demographic.date" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.document">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.document1"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.document" v-model="demographic.document" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.phone">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.phone"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.phone" v-model="demographic.phone" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.address">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.address"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.address" v-model="demographic.address" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.city">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.city"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.city" v-model="demographic.city" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.province">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.province"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.province" v-model="demographic.province" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label-for="demographic.country">
                    <template slot="label">{{
                      $t(
                        "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.country"
                      )
                    }}: *
                    </template>
                    <b-form-input id="demographic.country" v-model="demographic.country" :disabled="true"
                      type="text"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </tab-content-item>
            <tab-content-item id="tab-nav-data-templates" :active="false">
              <div class="text-right mb-2">
                <b-button v-if="historicStore &&
                  historicStore.historics &&
                  historicStore.historics.length !== 0 &&
                  checkPermissionProfessional('CONTACT_HISTORIC', ['EDIT']) &&
                  readOnly === false
                  " class="mr-2" style="right" variant="success" @click="saveCompleting">{{
    $t(
      "public.views.Pages.Professional.Contact.HistoricClinics.btnSave"
    )
  }}
                </b-button>
                <b-button v-if="((historicStore &&
                      historicStore.historics &&
                      historicStore.historics.length < 3) ||
                      !historicStore.historics) &&
                    checkPermissionProfessional('CONTACT_HISTORIC', [
                      'CREATE',
                    ]) &&
                    readOnly === false &&
                    !isHistoricShare
                    " class="mr-2" style="right" variant="success" @click="viewCreateByTemplate">{{
      $t(
        "public.views.Pages.Professional.Contact.HistoricClinics.add"
      )
    }}
                </b-button>
                <b-button v-if="checkPermissionProfessional('CONTACT_HISTORIC', [
                      'CREATE',
                    ]) &&
                    readOnly === false &&
                    !isHistoricShare
                    " class="mr-2 btn-flat" style="right" variant="success" @click="goToCreateTemplate">{{
      $t(
        "public.views.Pages.Professional.Contact.HistoricClinics.createTemplate"
      )
    }}
                </b-button>
              </div>
              <div v-if="historicStore &&
                  historicStore.historics &&
                  historicStore.historics.length !== 0
                  ">
                <div v-for="(item, index) in historicStore.historics" v-bind:key="index">
                  <tab-nav :tabs="true">
                    <tab-nav-items v-for="(option, index) in item.tabs" :id="'tab-nav-' + index" :key="index"
                      :active="index < 1" :ariaSelected="true" :href="'#tab-' + index" role="tab">
                      <template v-slot:title>
                        {{
                          option.name
                        }}<span v-if="option.permissionPatient"><i :id="'unlock_patient_tab_' + index"
                            class="ri-lock-unlock-line text-danger"></i></span>
                        <b-popover v-if="option.permissionPatient" :target="'unlock_patient_tab_' + index"
                          placement="botton" triggers="hover focus">
                          <template #title>{{
                            $t(
                              "public.views.Pages.Professional.Contact.HistoricClinics.sharedPatient"
                            )
                          }}
                          </template>
                        </b-popover>
                      </template>
                    </tab-nav-items>
                  </tab-nav>
                  <tab-content>
                    <tab-content-item v-for="(option, index) in item.tabs" :id="'tab-' + index" :key="index"
                      :active="index < 1">
                      <div class="test-survey-builder">
                        <b-row>
                          <b-col v-for="(question, index) in option.questionsList" :key="index"
                            :cols="item.numCol === null ? 12 : item.numCol">
                            <div class="border p-3">
                              <div class="question-section">
                                <div v-if="question.professional" class="text-right">
                                  <div class="media align-items-center">
                                    <div class="media-support-info ml-3">
                                      <p class="mb-0 font-size-12">
                                        <b-avatar v-bind:src="question.professional.avatar
                                          "></b-avatar>
                                        {{ question.professional.name }}
                                        {{ question.professional.lastname }} -
                                        {{
                                          question.createdAt
                                          | adjustToTimezone("DD/MM/YYYY HH:mm")
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <p class="question_body">
                                  {{
                                    question.body
                                  }}<span v-if="question.permissionPatient" class="ml-1"><i :id="'unlock_patient_tab_question_' + index
  " class="ri-lock-unlock-line text-danger"></i></span>
                                  <b-popover v-if="option.permissionPatient" :target="'unlock_patient_tab_question_' + index
                                    " placement="botton" triggers="hover focus">
                                    <template #title>{{
                                      $t(
                                        "public.views.Pages.Professional.Contact.HistoricClinics.sharedPatient"
                                      )
                                    }}
                                    </template>
                                  </b-popover>
                                </p>
                              </div>
                              <div class="answer-section">
                                <div v-if="question.type === 'BOOLEAN'" class="option-section">
                                  <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-radio v-for="(
                                                                                              option, index
                                                                                            ) in question.options"
                                      :key="index" v-model="question.value" :aria-describedby="ariaDescribedby"
                                      :disabled="readOnly" :name="'booleanSelect' + question.uuid"
                                      :value="option.sequence">{{ option.body }}
                                    </b-form-radio>
                                  </b-form-group>
                                </div>
                                <div v-if="question.type === 'TEXT'" class="option-section">
                                  <b-form-input v-if="question.characterLimited" v-model="question.value"
                                    :maxlength="question.textLimit" :readonly="readOnly" min="0" type="text" />
                                  <b-form-input v-if="!question.characterLimited" v-model="question.value"
                                    :readonly="readOnly" type="text" />
                                </div>
                                <div v-if="question.type === 'FILE'" class="option-section">
                                  <vue-dropzone :id="'dropzone' + question.uuid" :options="dropzoneOptions"
                                    @vdropzone-success="
                                      vdropzoneSuccess(question, ...arguments)
                                      "></vue-dropzone>
                                </div>
                                <div v-if="question.type === 'RATING'" class="option-section">
                                  <b-form-rating :id="'rating' + question.uuid" v-model="question.value"
                                    variant="warning"></b-form-rating>
                                </div>
                                <div v-if="question.type === 'DATE'" class="option-section">
                                  <b-form-datepicker :id="'form-datapiker-' + question.uuid" v-model="question.value"
                                    class="mb-2"></b-form-datepicker>
                                </div>
                                <div v-if="question.type === 'TIME'" class="option-section">
                                  <vue-timepicker v-model="question.valueTmp" :readonly="readOnly"></vue-timepicker>
                                </div>
                                <div v-if="question.type === 'NUMBER'" class="option-section">
                                  <div>
                                    <b-form-input v-if="question.hasMinMax &&
                                      !question.allowDecimals
                                      " v-model="question.value" :max="question.maxValue" :min="question.minValue"
                                      :readonly="readOnly" type="range">
                                      {{ question.value }}
                                    </b-form-input>
                                    <b-form-input v-if="!question.hasMinMax &&
                                      question.allowDecimals
                                      " v-model="question.value" :readonly="readOnly" step="0.01" type="number">
                                    </b-form-input>
                                    <b-form-input v-if="!question.hasMinMax &&
                                      !question.allowDecimals
                                      " v-model="question.value" :readonly="readOnly" type="number">
                                    </b-form-input>
                                    <b-form-input v-if="question.hasMinMax &&
                                      question.allowDecimals
                                      " v-model="question.value" :max="question.maxValue" :min="question.minValue"
                                      :readonly="readOnly" step="0.01" type="range">
                                    </b-form-input>
                                    <div v-if="question.hasMinMax">
                                      {{ question.value }}
                                    </div>
                                  </div>
                                </div>
                                <div v-if="question.type === 'SINGLE_CHOICE'" class="option-section">
                                  <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-radio v-for="(
                                                                                              option, index
                                                                                            ) in question.options"
                                      :key="index" v-model="question.value" :aria-describedby="ariaDescribedby"
                                      :disabled="readOnly" :value="option.body" name="singleSelect">{{ option.body }}
                                    </b-form-radio>
                                  </b-form-group>
                                </div>
                              </div>
                              <div v-if="question.type === 'TEXTAREA'" class="option-section">
                                <b-form-textarea :id="'textarea' + question.uuid" v-model="question.value" max-rows="6"
                                  rows="3"></b-form-textarea>
                              </div>
                              <div v-if="question.type === 'EDITOR'" class="option-section">
                                <ckeditor :id="'ckeditor' + question.uuid" v-model="question.value" :config="configCK"
                                  type="classic"></ckeditor>
                              </div>
                              <div v-if="question.type === 'MULTI_CHOICE'" class="option-section">
                                <b-form-group v-slot="{ ariaDescribedby }">
                                  <b-form-checkbox-group v-model="question.valueTmp"
                                    @input="multiChoiceTransformJson(question)">
                                    <b-form-checkbox v-for="(
                                                                                              option, index
                                                                                            ) in question.options"
                                      :key="index" :aria-describedby="ariaDescribedby" :name="'multiChoiceSelect' + question.uuid
                                        " :value="option.sequence">{{ option.body }}
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                </b-form-group>
                              </div>
                              <div>
                                <b-button v-b-toggle.collapse-1 class="mt-2" variant="primary">Ver hístorico
                                </b-button>
                                <b-collapse id="collapse-1" class="mt-2">
                                  <b-card>
                                    <div v-for="(
                                                                                              question, index
                                                                                            ) in question.versions"
                                      :key="index">
                                      <b-row>
                                        <b-col>
                                          <b-list-group-item v-if="question.professional" class="
                                                                                                    d-flex
                                                                                                    align-items-center
                                                                                                    border-0
                                                                                                    p-0
                                                                                                  ">
                                            <b-avatar v-bind:src="question.professional.avatar
                                              "></b-avatar>
                                            <div class="media-support-info ml-3">
                                              <p class="mb-0 font-size-16">
                                                {{ question.professional.name }}
                                              </p>
                                              <p class="mb-0 font-size-12">
                                                {{
                                                  question.professional.lastname
                                                }}
                                              </p>
                                            </div>
                                          </b-list-group-item>
                                        </b-col>
                                        <b-col>
                                          {{
                                            question.createdAt
                                            | adjustToTimezone("DD/MM/YYYY HH:mm")
                                          }}
                                        </b-col>
                                        <b-col>
                                          {{ question.answer }}
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </b-card>
                                </b-collapse>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </tab-content-item>
                  </tab-content>
                </div>
              </div>

              <div v-else>
                <b-alert show variant="warning">{{
                  $t(
                    "public.views.Pages.Professional.Contact.HistoricClinics.alert"
                  )
                }}
                </b-alert>
              </div>
            </tab-content-item>
          </tab-content>
        </div>
      </template>
      <b-modal id="modal-createFromTemplate" centered @ok="saveForm1">
        <template #modal-title>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalCreateFromTemplate.title"
            )
          }}
        </template>
        <template #modal-ok>{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalCreateFromTemplate.btnCreate"
          )
        }}
        </template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalCreateFromTemplate.btnClose"
          )
        }}
        </template>
        <p>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalCreateFromTemplate.body"
            )
          }}
        </p>
        <b-form-group label-for="template">
          <template slot="label">{{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalCreateFromTemplate.template"
            )
          }}: *
          </template>
          <b-select v-model="template" :options="professionalTemplatesSelect" v-bind:class="{
            'text-danger': isFormTemplateErrors,
            'is-invalid': isFormTemplateErrors,
          }" @blur="checkTemplate(name)"></b-select>

          <ul v-if="isFormTemplateErrors">
            <li v-for="(error, index) in validatorStep2.getErrors('template')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </b-modal>
      <b-modal id="modal-generate-pdf" centered @ok="generatePdf">
        <template #modal-title>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.generateReport"
            )
          }}
        </template>
        <template #modal-ok>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.generate"
            )
          }}
        </template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.close"
          )
        }}
        </template>
        <template>
          <div>
            <h4>
              {{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.demographicData"
                )
              }}:
            </h4>
            <tree ref="tree" v-model="treeModelDemographic" :data="itemsDemographic" :options="optionsTree" />
          </div>
          <div>
            <h4>
              {{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.templates"
                )
              }}:
            </h4>
            <tree ref="tree" v-model="treeModel" :data="items" :options="optionsTree" />
          </div>
          <div>
            <h4>
              {{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.notes"
                )
              }}:
            </h4>
            <tree ref="tree" v-model="treeModelNotes" :data="itemsNotes" :options="optionsTree" />
          </div>
        </template>
      </b-modal>
      <b-modal id="modal-generate-word" centered @ok="generateWord">
        <template #modal-title>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.generateReport"
            )
          }}
        </template>
        <template #modal-ok>
          {{
            $t(
              "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.generate"
            )
          }}
        </template>
        <template #modal-cancel>{{
          $t(
            "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.close"
          )
        }}
        </template>
        <template>
          <div>
            <h4>
              {{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.demographicData"
                )
              }}:
            </h4>
            <tree ref="tree" v-model="treeModelDemographic" :data="itemsDemographic" :options="optionsTree" />
          </div>
          <div>
            <h4>
              {{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.templates"
                )
              }}:
            </h4>
            <tree ref="tree" v-model="treeModel" :data="items" :options="optionsTree" />
          </div>
          <div>
            <h4>
              {{
                $t(
                  "public.views.Pages.Professional.Contact.HistoricClinics.modalPDF.notes"
                )
              }}:
            </h4>
            <tree ref="tree" v-model="treeModelNotes" :data="itemsNotes" :options="optionsTree" />
          </div>
        </template>
      </b-modal>
    </iq-card>
    <b-modal id="modal-create" cancel-title="Cerrar" centered hide-footer>
      <template #modal-title> Ver grabación</template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Share.modalCreate.close")
      }}
      </template>
      <b-form-group label-for="name">
        <template slot="label">{{ $t("public.views.Pages.Share.name") }}: *
        </template>
        <b-form-input id="name" v-model="name" :disabled="true" type="text"></b-form-input>
      </b-form-group>

      <b-form-group label-for="file">
        <template slot="label">{{ $t("public.views.Pages.Share.file") }}: *
        </template>
        <a v-if="fileData && fileName" :download="fileName" :href="'data:application/octet-stream;base64,' + fileData">
          <i class="fas fa-download fa-fw"></i>{{ fileName }}
        </a>
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import Vue from 'vue';
import routes from "../../../../router/index";
import { mapActions, mapGetters } from "vuex";

import { xray } from "../../../../config/pluginInit";
import validator from "vue-m-validator";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import { saveAs } from "file-saver";

import SurveyBuilder from "../../../../components/survey/SurveyBuilder";
import QuestionsView from "../../../../components/survey/QuestionsView";

import HistoricsFiles from "../../../../components/historics/HistoricsFiles";

import organizationService from "../../../../services/organization";
import historicService from "../../../../services/historic";
import professionalService from "../../../../services/professional";
import patientService from "../../../../services/patient";
import shareService from "../../../../services/share";
import utilsService from "../../../../services/utils";


export default {
  name: "HistoricClinics",

  computed: {
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
  },

  mounted() {
    xray.index();

    this.getAllHistoricsStoreShare();
    this.getAllHistoricsStore();
    this.getOrganization();

    this.$root.$on("add-update-question", (q, tab) => {
      this.updateQuestionsList(q, tab);
    });

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
  },
  watch: {
    paginationShare: {
      handler() {
        if (this.start) {
          this.getAllShares();
        }
        this.start = true;
      },
    },
    pagination: {
      handler() {
        if (this.start) {
          this.getAllHistoricsStore();
        }
        this.start = true;
      },
    },
  },
  components: {
    SurveyBuilder,
    QuestionsView,
    "vue-dropzone": vue2Dropzone,
    DatePicker,
    VueTimepicker,
    Multiselect,
    HistoricsFiles
  },
  computed: {
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormPatientErrors() {
      let errors = this.validatorStep1.getErrors("patient");
      return errors && errors.length > 0;
    },
    isFormTemplateErrors() {
      let errors = this.validatorStep2.getErrors("template");
      return errors && errors.length > 0;
    },
    isFormProfessionalPermissionProfessionalErrors() {
      let errors = this.validatorStep3.getErrors(
        "professionalPermission.professional"
      );
      return errors && errors.length > 0;
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(localStorage.getItem("organizationId")),
        (response) => {
          if (response) {
            this.organization = response.data;

            if (this.organization && this.organization.isGalatea) {
              self.headers = self.headersGalatea;
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            })
          });
        },
        " "
      );
    },
    getShare(id) {
      let self = this;
      this.$awn.asyncBlock(
        shareService.get(id),
        (response) => {
          if (response) {
            self.cleanAll();
            self.id = response.data.id;
            self.userFrom = response.data.from;
            self.usersTo = response.data.to;
            self.name = response.data.name;
            self.category = response.data.category;
            if (response.data.file) {
              self.fileUUID = response.data.file.uuid.replace("/", "");
              self.fileName = response.data.file.name;
              self.fileData = response.data.file.data;
            }
            self.$bvModal.show("modal-create");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.get",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    openModal(action, id) {
      this.action = action;

      if (this.action === "UPDATE") {
        this.getShare(id);
      } else {
        this.cleanAll();
        this.$bvModal.show("modal-create");
      }
    },
    cleanAll() {
      this.name = "";
      this.usersTo = [];
      this.fileUUID = "";
      this.category = "";
      this.fileUUID = "";
      this.fileName = "";
      this.fileData = "";
    },
    downloadBlob(blob, name = "file.txt") {
      if (window.navigator && window.navigator.msSaveOrOpenBlob)
        return window.navigator.msSaveOrOpenBlob(blob);

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = data;
      link.download = name;

      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    },
    downloadFile(uuid, filename) {
      let self = this;
      this.$awn.asyncBlock(
        utilsService.getFile(uuid),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/octet-stream;base64",
              name: "prueba",
            });

            saveAs(file, filename);
          }
        },
        (error) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Share.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Share.notification.descErrorDwn"
            ),
            type: "error",
          });
        },
        ""
      );
    },
    async getAllShares() {
      let self = this;
      this.$awn.asyncBlock(
        shareService.getAllVideoconference(
          this.paginationShare.page - 1,
          this.paginationShare.itemsPerPage,
          this.patientId
        ),
        (response) => {
          if (response) {
            self.shares = response.data.content;
            self.totalShare = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.getAllVideoconference",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.paginationShare.page - 1,
              itemsPerPage: this.paginationShare.itemsPerPage,
              patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    goToCreateTemplate() {
      routes.push({ name: "auth.professional.organization.historicclinic" });
    },
    changeNotSecuredPatientPermission() {
      this.changeNotSecured(this.patientPermission.id);
    },
    resetActions() {
      this.readOnly = false;
      this.isHistoricShare = false;
    },
    getHistoricStoreShare(id, idPatient, action) {
      this.isHistoricShare = true;
      if (action === "UPDATE") {
        this.readOnly = false;
      }
      if (action === "READ") {
        this.readOnly = true;
      }
      this.getHistoricStore(id, idPatient);
    },
    getProfessionalPermission(id) {
      let self = this;

      this.$awn.asyncBlock(
        historicService.getProfessionalPermission(this.historicStoreId, id),
        (response) => {
          if (response) {
            let professional = {
              value: response.data.professional.id,
              text:
                response.data.professional.name +
                " " +
                response.data.professional.lastname,
              avatar: response.data.professional.avatar,
            };

            let professionals = [];

            professionals.push(professional);

            self.professionalPermission = {
              id: response.data.id,
              professional: professionals,
              permission: response.data.permission,
            };

            self.$bvModal.hide("modal-professional-permission");
            self.$bvModal.show("modal-professional-permission-create");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.getProfessionalPermission",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: this.historicStoreId, id: id
            })
          });
        },
        " "
      );
    },
    deleteProfessionalPermission(id) {
      let self = this;

      this.$awn.asyncBlock(
        historicService.deleteProfessionalPermissions(this.historicStoreId, id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descUnlinkPatient"
              ),
              type: "success",
            });
            self.getAllProfessionalPermission(self.historicStoreId);
            self.getAllHistoricsStore();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.deleteProfessionalPermissions",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: this.historicStoreId, id: id
            })
          });
        },
        " "
      );
    },
    updateProfessionalPermission() {
      let self = this;

      let data = {};

      this.professionalPermission.professional.forEach(function (professional) {
        let item = {
          id: self.professionalPermission.id,
          professional: professional.value,
          permission: self.professionalPermission.permission,
        };

        data = item;
      });

      this.$awn.asyncBlock(
        historicService.updateProfessionalPermissions(
          this.historicStoreId,
          this.professionalPermission.id,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descRefreshPermision"
              ),
              type: "success",
            });
            self.getAllProfessionalPermission(self.historicStoreId);
            self.$bvModal.hide("modal-professional-permission-create");
            self.$bvModal.show("modal-professional-permission");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.updateProfessionalPermissions",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: this.historicStoreId,
              professionalPermission: this.professionalPermission.id,
              data: data
            })
          });
        },
        " "
      );
    },
    createProfessionalPermission() {
      let self = this;

      let data = [];

      this.professionalPermission.professional.forEach(function (professional) {
        let item = {
          professional: professional.value,
          permission: self.professionalPermission.permission,
        };

        data.push(item);
      });

      this.$awn.asyncBlock(
        historicService.createProfessionalPermissions(
          this.historicStoreId,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descLinkPatient"
              ),
              type: "success",
            });
            self.getAllProfessionalPermission(self.historicStoreId);
            self.$bvModal.hide("modal-professional-permission-create");
            self.$bvModal.show("modal-professional-permission");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.createProfessionalPermissions",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: this.historicStoreId,
              data: data
            })
          });
        },
        " "
      );
    },
    getAllProfessionals() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllActive(),
        (response) => {
          if (response) {
            let combo = [];

            if (response.data && response.data.length !== 0) {
              response.data.forEach(function (professional) {
                let exist = false;
                self.professionalPermissions.forEach(function (
                  professionalPermission
                ) {
                  if (
                    professionalPermission.professional.id === professional.id
                  ) {
                    exist = true;
                  }
                });
                if (!exist) {
                  combo.push({
                    value: professional.id,
                    text: professional.name + " " + professional.lastname,
                    avatar: professional.avatarUrl
                      ? professional.avatarUrl +
                      "/" +
                      localStorage.getItem("authorization")
                      : "",
                  });

                  self.professionalPermisionsSelect = combo;
                }
              });
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllActive",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
    openProfessionalPermissionUpdate(id) {
      this.getAllProfessionals();
      this.actionProfessionalPermisions = "UPDATE";
      this.getProfessionalPermission(id);
    },
    openProfessionalPermissionCreate(evt) {
      this.getAllProfessionals();
      this.actionProfessionalPermisions = "CREATE";
      this.$bvModal.hide("modal-professional-permission");
      this.$bvModal.show("modal-professional-permission-create");
    },
    openPatientPermissionCreate(id, idPatient, secured) {
      this.patientPermission.id = id;
      this.patientPermission.secured = secured;

      this.loadHistoricStore(id, idPatient);
    },
    patientPermissionCreate() {
      if (this.patientPermission.secured) {
        this.changeNotSecured(this.patientPermission.id);
      } else {
        this.changeSecured(this.patientPermission.id);
      }
    },
    openProfessionalPermission(id) {
      this.historicStoreId = id;
      this.getAllProfessionalPermission(id);
    },
    generateWord() {
      let self = this;

      if (
        self.treeModel &&
        self.treeModel.checked &&
        self.treeModel.checked.length !== 0 &&
        self.items &&
        self.items.length !== 0
      ) {
        self.items.forEach(function (item) {
          item.state.checked = false;

          //Tabs
          if (item.children) {
            item.children.forEach(function (tab) {
              tab.state.checked = false;

              // Questions
              tab.children.forEach(function (question) {
                question.state.checked = false;
              });
            });
          }
        });
        self.treeModel.checked.forEach(function (check) {
          self.items.forEach(function (item) {
            if (
              check.data.uuid &&
              item.data.uuid &&
              check.data.uuid === item.data.uuid
            ) {
              item.state.checked = true;
            }

            //Tabs
            if (item.children) {
              item.children.forEach(function (tab) {
                if (
                  check.data.uuid &&
                  tab.data.uuid &&
                  check.data.uuid === tab.data.uuid
                ) {
                  tab.state.checked = true;
                }

                // Questions
                tab.children.forEach(function (question) {
                  if (
                    check.data.uuid &&
                    question.data.uuid &&
                    check.data.uuid === question.data.uuid
                  ) {
                    question.state.checked = true;
                  }
                });
              });
            }
          });
        });
      }

      let demographicChecked = new Set();

      if (
        this.treeModelDemographic.checked &&
        this.treeModelDemographic.checked.length !== 0
      ) {
        this.treeModelDemographic.checked.forEach(function (item) {
          demographicChecked.add(item.data.name);
        });
      }

      let demographicPermission = {
        birthday: demographicChecked.has("birthday"),
        name: demographicChecked.has("name"),
        lastname: demographicChecked.has("lastname"),
        document: demographicChecked.has("document"),
        country: demographicChecked.has("country"),
        city: demographicChecked.has("city"),
        province: demographicChecked.has("province"),
        address: demographicChecked.has("address"),
        email: demographicChecked.has("email"),
        phone: demographicChecked.has("phone"),
      };

      let notes = [];

      // Get notes to print
      self.treeModelNotes.checked.forEach(function (check) {
        if (check.data) {
          notes.push(check.data.id);
        }
      });

      let data = {
        permissions: self.items,
        demographicPermission: demographicPermission,
        notes: notes
      };

      this.$awn.asyncBlock(
        professionalService.generateWordStoreHistoric(
          self.professional,
          self.idHistoricStore,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_HISTORIC_CLINIC_WORD", info: "" });
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "historia_clinica.docx");
            document.body.appendChild(fileLink);

            fileLink.click();

            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descGeneratedHC"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.generateWordStoreHistoric",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: self.professional,
              idHistoricStore: self.idHistoricStore,
              data: data
            })
          });
        },
        " "
      );
    },
    generatePdf() {
      let self = this;

      if (
        self.treeModel &&
        self.treeModel.checked &&
        self.treeModel.checked.length !== 0 &&
        self.items &&
        self.items.length !== 0
      ) {
        self.items.forEach(function (item) {
          item.state.checked = false;

          //Tabs
          if (item.children) {
            item.children.forEach(function (tab) {
              tab.state.checked = false;

              // Questions
              tab.children.forEach(function (question) {
                question.state.checked = false;
              });
            });
          }
        });
        self.treeModel.checked.forEach(function (check) {
          self.items.forEach(function (item) {
            if (
              check.data.uuid &&
              item.data.uuid &&
              check.data.uuid === item.data.uuid
            ) {
              item.state.checked = true;
            }

            //Tabs
            if (item.children) {
              item.children.forEach(function (tab) {
                if (
                  check.data.uuid &&
                  tab.data.uuid &&
                  check.data.uuid === tab.data.uuid
                ) {
                  tab.state.checked = true;
                }

                // Questions
                tab.children.forEach(function (question) {
                  if (
                    check.data.uuid &&
                    question.data.uuid &&
                    check.data.uuid === question.data.uuid
                  ) {
                    question.state.checked = true;
                  }
                });
              });
            }
          });
        });
      }

      let demographicChecked = new Set();

      if (
        this.treeModelDemographic.checked &&
        this.treeModelDemographic.checked.length !== 0
      ) {
        this.treeModelDemographic.checked.forEach(function (item) {
          demographicChecked.add(item.data.name);
        });
      }

      let demographicPermission = {
        birthday: demographicChecked.has("birthday"),
        name: demographicChecked.has("name"),
        lastname: demographicChecked.has("lastname"),
        document: demographicChecked.has("document"),
        country: demographicChecked.has("country"),
        city: demographicChecked.has("city"),
        province: demographicChecked.has("province"),
        address: demographicChecked.has("address"),
        email: demographicChecked.has("email"),
        phone: demographicChecked.has("phone"),
      };

      let notes = [];

      // Get notes to print
      self.treeModelNotes.checked.forEach(function (check) {
        if (check.data) {
          notes.push(check.data.id);
        }
      });

      let data = {
        permissions: self.items,
        demographicPermission: demographicPermission,
        notes: notes
      };

      this.$awn.asyncBlock(
        professionalService.generatePdfStoreHistoric(
          self.professional,
          self.idHistoricStore,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_HISTORIC_CLINIC_PDF", info: "" });
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "historia_clinica.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();

            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descGeneratedHC"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.generatePdfStoreHistoric",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: self.professional,
              idHistoricStore: self.idHistoricStore,
              data: data
            })
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    changeSecured(id) {
      let self = this;

      let data = {};

      this.$awn.asyncBlock(
        professionalService.changeSecuredHistoricStore(
          this.professional,
          id,
          true,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC_SECURED", info: "" });
            this.getAllHistoricsStore();

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descNotAvaliablePatient"
              ),
              type: "success",
            });

            self.$bvModal.hide("modal-patient-permission");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.changeSecuredHistoricStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional,
              id: id,
              data: data
            })
          });
        },
        " "
      );
    },
    changeNotSecured(id) {
      let self = this;

      if (
        self.treeModel &&
        self.treeModel.checked &&
        self.treeModel.checked.length !== 0 &&
        self.items &&
        self.items.length !== 0
      ) {
        self.items.forEach(function (item) {
          item.state.checked = false;

          //Tabs
          if (item.children) {
            item.children.forEach(function (tab) {
              tab.state.checked = false;

              // Questions
              tab.children.forEach(function (question) {
                question.state.checked = false;
              });
            });
          }
        });
        self.treeModel.checked.forEach(function (check) {
          self.items.forEach(function (item) {
            if (
              check.data.uuid &&
              item.data.uuid &&
              check.data.uuid === item.data.uuid
            ) {
              item.state.checked = true;
            }

            //Tabs
            if (item.children) {
              item.children.forEach(function (tab) {
                if (
                  check.data.uuid &&
                  tab.data.uuid &&
                  check.data.uuid === tab.data.uuid
                ) {
                  tab.state.checked = true;
                }

                // Questions
                tab.children.forEach(function (question) {
                  if (
                    check.data.uuid &&
                    question.data.uuid &&
                    check.data.uuid === question.data.uuid
                  ) {
                    question.state.checked = true;
                  }
                });
              });
            }
          });
        });
      }

      let notes = [];
      
      // Get notes to print
      self.treeModelNotes.checked.forEach(function (check) {
        notes.push(check.data.id);
      });

      let data = {
        permissions: self.items,
        demographicPermission: {},
        notes: notes
      };

      this.$awn.asyncBlock(
        professionalService.changeSecuredHistoricStore(
          this.professional,
          id,
          false,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_HISTORIC_CLINIC_SECURED", info: "" });
            this.getAllHistoricsStore();

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descAvaliablePatient"
              ),
              type: "warning",
            });
            self.$bvModal.hide("modal-patient-permission");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.changeSecuredHistoricStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional,
              id: id,
              data: data
            })
          });
        },
        " "
      );
    },
    multiChoiceTransformJson(question) {
      if (question.valueTmp && question.type === "MULTI_CHOICE") {
        question.value = JSON.stringify(question.valueTmp);
      }
    },
    updateTime(question) {
      if (question.valueTmp) {
        question.value = question.valueTmp.HH + ":" + question.valueTmp.mm;
      }
    },
    updateDate(question) {
      question.value = moment(question.valueTmp).format("DD/MM/yyyy");
    },
    vdropzoneSuccess: function (question, file, response) {
      question.value = response.uuid;
    },
    async getAllPatients() {
      let self = this;

      patientService
        .getAllActive()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              value: item.id,
              validatedBy: item.validatedBy,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
            };
            combo.push(data);
          });
          self.patientSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllActive",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    notFirst() {
      this.isFirstRun = false;
    },
    listTemplate() {
      this.page = "LIST_TEMPLATE";

      this.getAllHistoricsStore();
    },
    viewComplete() {
      this.cleanCreate();
      this.action = "COMPLETE";
      this.page = "TEMPLATE";
    },
    viewCreateTemplate() {
      this.getAllPatients();
      this.cleanCreate();
      this.$bvModal.show("modal-create");
    },
    viewCreateByTemplate() {
      this.getAllTemplates();
      this.cleanCreateByTemplate();
      this.$bvModal.show("modal-createFromTemplate");
    },
    viewPatientPermissions() {
      let self = this;

      this.items = [];

      if (
        this.historicStore.historics &&
        this.historicStore.historics.length !== 0
      ) {
        this.historicStore.historics.forEach(function (item) {
          let tabs = [];

          if (item.tabs && item.tabs.length !== 0) {
            item.tabs.forEach(function (tab) {
              let questions = [];

              if (tab.questionsList && tab.questionsList.length !== 0) {
                tab.questionsList.forEach(function (question) {
                  let questionNew = {
                    data: { uuid: question.uuid },
                    text: question.body,
                    state: { checked: question.permissionPatient },
                  };

                  questions.push(questionNew);
                });
              }

              let tabNew = {
                data: { uuid: tab.uuid },
                text: tab.name,
                children: questions,
                state: { checked: tab.permissionPatient, expanded: false },
              };

              tabs.push(tabNew);
            });
          }

          let itemNew = {
            data: { uuid: item.uuid },
            text: item.name,
            children: tabs,
            state: { checked: true, expanded: true },
          };

          self.items.push(itemNew);
        });
      }

      // Create demographic

      self.itemsDemographic = [];

      let itemNewDemographic = {
        data: { name: "name" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.name"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic1 = {
        data: { name: "lastname" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.lastname"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic2 = {
        data: { name: "document" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.document1"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic3 = {
        data: { name: "phone" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.phone"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic4 = {
        data: { name: "country" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.country"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic5 = {
        data: { name: "email" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.email"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic6 = {
        data: { name: "province" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.province"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic7 = {
        data: { name: "city" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.city"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic8 = {
        data: { name: "birthday" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.birth"
        ),
        children: [],
        state: { checked: false },
      };
      let itemNewDemographic9 = {
        data: { name: "address" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.address"
        ),
        children: [],
        state: { checked: false },
      };

      self.itemsDemographic.push(itemNewDemographic);
      self.itemsDemographic.push(itemNewDemographic1);
      self.itemsDemographic.push(itemNewDemographic2);
      self.itemsDemographic.push(itemNewDemographic3);
      self.itemsDemographic.push(itemNewDemographic4);
      self.itemsDemographic.push(itemNewDemographic5);
      self.itemsDemographic.push(itemNewDemographic6);
      self.itemsDemographic.push(itemNewDemographic7);
      self.itemsDemographic.push(itemNewDemographic8);
      self.itemsDemographic.push(itemNewDemographic9);


      // Create notes

      self.itemsNotes = [];

      self.notes.forEach(function (note) {
        const adjustedTimestamp = Vue.filter("adjustToTimezone")(note.createdAt);
        let n = {
          data: { id: note.id },
          text: adjustedTimestamp,
          children: [],
          state: { checked: note.permissionPatient },
        };
        self.itemsNotes.push(n);
      })

      this.$bvModal.show("modal-patient-permission");
    },
    viewGenerateWord() {
      let self = this;

      this.items = [];

      if (
        this.historicStore.historics &&
        this.historicStore.historics.length !== 0
      ) {
        this.historicStore.historics.forEach(function (item) {
          let tabs = [];

          if (item.tabs && item.tabs.length !== 0) {
            item.tabs.forEach(function (tab) {
              let questions = [];

              if (tab.questionsList && tab.questionsList.length !== 0) {
                tab.questionsList.forEach(function (question) {
                  let questionNew = {
                    data: { uuid: question.uuid },
                    text: question.body,
                    state: { checked: true },
                  };

                  questions.push(questionNew);
                });
              }

              let tabNew = {
                data: { uuid: tab.uuid },
                text: tab.name,
                children: questions,
                state: { checked: true, expanded: false },
              };

              tabs.push(tabNew);
            });
          }

          let itemNew = {
            data: { uuid: item.uuid },
            text: item.name,
            children: tabs,
            state: { checked: true, expanded: true },
          };

          self.items.push(itemNew);
        });
      }

      // Create demographic

      self.itemsDemographic = [];

      let itemNewDemographic = {
        data: { name: "name" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.name"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic1 = {
        data: { name: "lastname" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.lastname"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic2 = {
        data: { name: "document" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.document1"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic3 = {
        data: { name: "phone" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.phone"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic4 = {
        data: { name: "country" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.country"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic5 = {
        data: { name: "email" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.email"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic6 = {
        data: { name: "province" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.province"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic7 = {
        data: { name: "city" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.city"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic8 = {
        data: { name: "birthday" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.birth"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic9 = {
        data: { name: "address" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.address"
        ),
        children: [],
        state: { checked: true },
      };

      self.itemsDemographic.push(itemNewDemographic);
      self.itemsDemographic.push(itemNewDemographic1);
      self.itemsDemographic.push(itemNewDemographic2);
      self.itemsDemographic.push(itemNewDemographic3);
      self.itemsDemographic.push(itemNewDemographic4);
      self.itemsDemographic.push(itemNewDemographic5);
      self.itemsDemographic.push(itemNewDemographic6);
      self.itemsDemographic.push(itemNewDemographic7);
      self.itemsDemographic.push(itemNewDemographic8);
      self.itemsDemographic.push(itemNewDemographic9);


      this.$bvModal.show("modal-generate-word");
    },
    viewGeneratePdf() {
      let self = this;

      this.items = [];

      if (
        this.historicStore.historics &&
        this.historicStore.historics.length !== 0
      ) {
        this.historicStore.historics.forEach(function (item) {
          let tabs = [];

          if (item.tabs && item.tabs.length !== 0) {
            item.tabs.forEach(function (tab) {
              let questions = [];

              if (tab.questionsList && tab.questionsList.length !== 0) {
                tab.questionsList.forEach(function (question) {
                  let questionNew = {
                    data: { uuid: question.uuid },
                    text: question.body,
                    state: { checked: true },
                  };

                  questions.push(questionNew);
                });
              }

              let tabNew = {
                data: { uuid: tab.uuid },
                text: tab.name,
                children: questions,
                state: { checked: true, expanded: false },
              };

              tabs.push(tabNew);
            });
          }

          let itemNew = {
            data: { uuid: item.uuid },
            text: item.name,
            children: tabs,
            state: { checked: true, expanded: true },
          };

          self.items.push(itemNew);
        });
      }

      // Create demographic

      self.itemsDemographic = [];

      let itemNewDemographic = {
        data: { name: "name" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.name"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic1 = {
        data: { name: "lastname" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.lastname"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic2 = {
        data: { name: "document" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.document1"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic3 = {
        data: { name: "phone" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.phone"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic4 = {
        data: { name: "country" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.country"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic5 = {
        data: { name: "email" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.email"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic6 = {
        data: { name: "province" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.province"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic7 = {
        data: { name: "city" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.city"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic8 = {
        data: { name: "birthday" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.birth"
        ),
        children: [],
        state: { checked: true },
      };
      let itemNewDemographic9 = {
        data: { name: "address" },
        text: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.modalCreate.address"
        ),
        children: [],
        state: { checked: true },
      };

      self.itemsDemographic.push(itemNewDemographic);
      self.itemsDemographic.push(itemNewDemographic1);
      self.itemsDemographic.push(itemNewDemographic2);
      self.itemsDemographic.push(itemNewDemographic3);
      self.itemsDemographic.push(itemNewDemographic4);
      self.itemsDemographic.push(itemNewDemographic5);
      self.itemsDemographic.push(itemNewDemographic6);
      self.itemsDemographic.push(itemNewDemographic7);
      self.itemsDemographic.push(itemNewDemographic8);
      self.itemsDemographic.push(itemNewDemographic9);

      // Create notes

      self.itemsNotes = [];

      self.notes.forEach(function (note) {
        const adjustedTimestamp = Vue.filter("adjustToTimezone")(note.createdAt);
        let n = {
          data: { id: note.id },
          text: adjustedTimestamp,
          children: [],
          state: { checked: true },
        };
        self.itemsNotes.push(n);
      })

      this.$bvModal.show("modal-generate-pdf");
    },
    cleanProfessionalPermission() {
      this.professionalPermission = {
        id: "",
        professional: [],
        permission: "READ",
      };
      this.validatorStep3.errors = [];
    },
    cleanCreateByTemplate() {
      this.template = "";
      this.patient = {};
      this.validatorStep2.errors = [];
    },
    cleanCreate() {
      this.patient = {};
      this.name = "";
      this.validatorStep1.errors = [];
    },
    addHistoricToHistoricStore() {
      let self = this;

      let data = {
        id: this.idHistoricStore,
        idTemplate: this.template,
      };

      this.$awn.asyncBlock(
        professionalService.addHistoricToHistoricStore(
          this.professional,
          this.template,
          data
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
            self.listTemplate();
            self.$bvModal.hide("modal-createFromTemplate");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descTemplateAdd"
              ),
              type: "success",
            });
            self.getHistoricStore(
              self.idHistoricStore,
              response.data.patient.id
            );
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.addHistoricToHistoricStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional,
              template: this.template,
              data: data
            })
          });
        },
        " "
      );
    },
    initForm() {
      let self = this;
      if (self.historicStore.historics) {
        self.historicStore.historics.forEach(function (historic) {
          if (historic.tabs) {
            historic.tabs.forEach(function (tab) {
              if (tab.questionsList) {
                tab.questionsList.forEach(function (question) {
                  if (question.type === "DATE") {
                    question.valueTmp = moment(
                      question.value,
                      "DD/MM/YYYY"
                    ).toDate();
                  }
                });
              }
            });
          }
        });
      }
    },
    loadHistoricStore(id, idPatient) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.findHistoricsStore(
          this.professional,
          idPatient,
          id
        ),
        (response) => {
          if (response) {
            self.idHistoricStore = id;
            self.historicStore = response.data;

            if (response.data.patient) {
              self.demographic.email = response.data.patient.email;
              self.demographic.name = response.data.patient.name;
              self.demographic.phone = response.data.patient.phone;
              self.demographic.lastname = response.data.patient.lastname;
              self.demographic.document = response.data.patient.document;
              self.demographic.city = response.data.patient.city;
              self.demographic.country = response.data.patient.country;
              self.demographic.province = response.data.patient.province;
              self.demographic.address = response.data.patient.address;
            }

            historicService
              .getNotesByHistoricStore(id)
              .then((response) => {
                if (response) {
                  self.notes = response.data;
                  self.viewPatientPermissions();
                }
              })

          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.findHistoricsStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional,
              idPatient: idPatient,
              id: id
            })
          });
        },
        " "
      );
    },
    getHistoricStoreOld(patientId) {
      routes.push({
        name: "auth.professional.historicOld",
        query: { patientId: patientId },
      });
    },
    getHistoricStore(id, patientId) {
      let self = this;

      this.patientId = patientId;

      this.$awn.asyncBlock(
        professionalService.findHistoricsStore(
          this.professional,
          patientId,
          id
        ),
        (response) => {
          if (response) {
            self.idHistoricStore = id;
            self.historicStore = response.data;

            if (response.data.patient) {
              self.getAllShares();
              self.demographic.email = response.data.patient.email;
              self.demographic.name = response.data.patient.name;
              self.demographic.phone = response.data.patient.phone;
              self.demographic.lastname = response.data.patient.lastname;
              self.demographic.document = response.data.patient.document;
              self.demographic.city = response.data.patient.city;
              self.demographic.country = response.data.patient.country;
              self.demographic.province = response.data.patient.province;
              self.demographic.address = response.data.patient.address;
            }

            self.initForm();

            self.viewComplete();

            self.getAllNotes(id);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.findHistoricsStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional,
              patientId: patientId,
              id: id
            })
          });
        },
        " "
      );
    },
    createHistoricsStoreNote() {
      let self = this;

      if (this.note.content !== "" && this.note.content.length < 10000) {
        this.$awn.asyncBlock(
          historicService.createNotesByHistoricStore(
            this.idHistoricStore,
            this.note
          ),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC_NOTE", info: "" });
              self.getAllNotes(self.idHistoricStore);
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "historicService.createNotesByHistoricStore",
              module: "view-pages-professional-contact-hc",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                idHistoricStore: this.idHistoricStore,
                note: this.note
              })
            });
          },
          " "
        );
      } else {
        this.$swal("Solo se permiten notas de hasta 20000 carácteres");
      }
    },
    createHistoricsStore() {
      let self = this;

      let data = {
        name: this.name,
        professional: localStorage.getItem("userId"),
        patient: this.patient.value,
      };
      this.$awn.asyncBlock(
        professionalService.createHistoricsStore(data, this.professional),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
            self.listTemplate();
            self.$bvModal.hide("modal-create");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descCreateHC"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.createHistoricsStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data,
              professional: this.professional
            })
          });
        },
        " "
      );
    },
    saveCompleting() {
      let self = this;

      let data = {
        id: self.historicStore.id,
        professional: self.historicStore.professional.id,
        patient: self.historicStore.patient.id,
        name: self.historicStore.name,
        historics: this.historicStore.historics,
      };

      this.$awn.asyncBlock(
        professionalService.saveHistoricsStore(data, this.professional),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_HISTORIC_CLINIC", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Contact.HistoricClinics.notification.descSaveHC"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.saveHistoricsStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data,
              professional: this.professional
            })
          });
        },
        " "
      );
    },
    async getAllProfessionalPermission(historicStoreId) {
      let self = this;

      this.$awn.asyncBlock(
        historicService.getProfessionalPermissions(historicStoreId),
        (response) => {
          if (response) {
            self.professionalPermissions = response.data;
            self.cleanProfessionalPermission();
            self.$bvModal.show("modal-professional-permission");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.getProfessionalPermissions",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: historicStoreId
            })
          });
        },
        " "
      );
    },
    async getAllHistoricsStoreShare() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllHistoricsStoreShare(this.professional),
        (response) => {
          if (response) {
            self.templatesShare = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllHistoricsStoreShare",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional
            })
          });
        },
        " "
      );
    },
    async getAllHistoricsStore() {
      let self = this;

      let data = {
        name: this.search,
      };

      this.$awn.asyncBlock(
        professionalService.getAllHistoricsStorePerformance(
          this.professional,
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          if (response) {
            self.templates = response.data.content;
            self.total = response.data.pageable.total;
            self.total = response.data.pageable.total;
            if (self.pagination.page > response.data.pageable.totalPages) {
              self.pagination.page = response.data.pageable.totalPages;
            }
            self.resetActions();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllHistoricsStorePerformance",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional,
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );
    },
    checkFormStep2() {
      this.checkTemplate(this.template);
    },
    checkFormStep1() {
      this.checkPatient(this.patient);
      this.checkName(this.name);
    },
    saveForm(evt) {
      evt.preventDefault();

      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        this.createHistoricsStore();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.notification.descErrorHC"
          ),
          type: "error",
        });
      }
    },

    saveForm1(evt) {
      evt.preventDefault();

      this.checkFormStep2();
      if (this.validatorStep2.errors.length === 0) {
        this.addHistoricToHistoricStore();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.notification.descErrorTemplate"
          ),
          type: "error",
        });
      }
    },

    checkFormStep3() {
      this.checkProfessionalPermissionProfessional(
        this.professionalPermission.professional
      );
    },

    saveForm3(evt) {
      evt.preventDefault();

      this.checkFormStep3();
      if (this.validatorStep3.errors.length === 0) {
        if (this.actionProfessionalPermisions === "CREATE") {
          this.createProfessionalPermission();
        }
        if (this.actionProfessionalPermisions === "UPDATE") {
          this.updateProfessionalPermission();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.notification.descErrorPermision"
          ),
          type: "error",
        });
      }
    },

    checkProfessionalPermissionProfessional(_professional) {
      const PROFESSIONAL = _professional;
      const RULE_1 = {
        expression: !PROFESSIONAL,
        name: "professionalPermission.professional",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.errors.erProfessional"
        ),
      };
      this.validatorStep3.addRule(RULE_1);
      this.notFirst();
    },
    checkPatient(_patient) {
      const PATIENT = _patient != null ? _patient.toString() : null;
      const RULE_1 = {
        expression: !PATIENT || PATIENT === "",
        name: "patient",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.errors.erPatient"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkTemplate(_template) {
      const TEMPLATE = _template != null ? _template.toString() : null;
      const RULE_1 = {
        expression: !TEMPLATE || TEMPLATE === "",
        name: "template",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.errors.erTemplate"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Contact.HistoricClinics.errors.erName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    async getAllNotes(historicStoreId) {
      let self = this;

      this.note.content = "";

      historicService
        .getNotesByHistoricStore(historicStoreId)
        .then((response) => {
          if (response) {
            self.notes = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.getNotesByHistoricStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: historicStoreId
            })
          });
        });
    },
    async getAllTemplates() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllTemplates(this.professional),
        (response) => {
          if (response) {
            let combo = [];
            response.data.forEach(function (item) {
              let name = "";

              if (item.name) {
                name = name + item.name + " ";
              }

              combo.push({
                value: item.uuid,
                text: name,
              });
            });
            self.professionalTemplatesSelect = combo;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllTemplates",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional
            })
          });
        },
        " "
      );
    },
  },

  data() {
    return {
      start: false,
      fileData: "",
      //Patient
      patientPermission: { id: "", secure: false },
      //Professional
      isHistoricShare: false,
      actionProfessionalPermisions: "CREATE",
      historicStoreId: "",
      professionalPermisionsSelect: [],
      professionalPermission: { id: "", professional: [], permission: "READ" },
      headersProfessionalPermissions: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.professional"
          ),
          align: "start",
          value: "professional",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.permision"
          ),
          value: "permission",
        },
        { text: "", value: "actions" },
      ],
      professionalPermissions: [],
      demographic: {
        email: "",
        name: "",
        lastname: "",
        birthday: "",
        phone: "",
        document: "",
        country: "",
        province: "",
        city: "",
        address: "",
      },
      note: {
        content: "",
      },
      notes: [],
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,
      treeModel: {},
      treeModelDemographic: {},
      treeModelNotes: {},
      items: [],
      itemsDemographic: [],
      itemsNotes: [],
      optionsTree: {
        checkbox: true,
      },
      //Patient object
      patient: {},
      shares: [],
      totalShare: 0,
      paginationShare: { page: 1, itemsPerPage: 10 },
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      readOnly: false,
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 10,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },

      disabled: false,
      isFirstRun: true,

      search: "",
      searchShare: "",
      action: "",
      page: "LIST_TEMPLATE",
      validatorStep1: validator,
      validatorStep2: validator,
      validatorStep3: validator,
      tabs: [],
      name: "",
      uuid: "",
      professional: localStorage.getItem("userId"),
      patient: "",
      patientId: null,
      addQuestion: false,

      patientSelect: [],
      professionalTemplatesSelect: [],
      templates: [],
      templatesShare: [],

      template: "",

      idHistoricStore: "",

      historicStore: [],
      headersTemplateShare: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.professional"
          ),
          value: "professional",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.patient"
          ),
          value: "patient",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.security"
          ),
          value: "secured",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.permision"
          ),
          value: "permission",
        },
        { text: "", value: "actions" },
      ],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.patient"
          ),
          value: "patient",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.security"
          ),
          value: "secured",
        },
        { text: "", value: "uuid" },
      ],
      headersGalatea: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.code"
          ),
          align: "start",
          value: "code",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.patient"
          ),
          value: "patient",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.professional"
          ),
          value: "professionalsGalatea",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Contact.HistoricClinics.headers.security"
          ),
          value: "secured",
        },
        { text: "", value: "uuid" },
      ],
      headersShare: [
        {
          text: "Fecha de creación",
          align: "start",
          value: "createdAt",
        },
        {
          text: "Título",
          value: "name",
        },
        {
          text: "Categoría",
          value: "category",
        },
        {
          text: "Nombre del archivo",
          value: "filename",
        },
        { text: "", value: "uuid" },
      ],
    };
  },
};
</script>
